const WA_LINK = 'https://wa.me/554891802091?text=Ol%C3%A1!%20Preciso%20de%20ajuda%20para%20escolher%20uma%20m%C3%A1quina%20de%20solda%20de%20geomembrana.';

export default function HelpCta() {
  const handleWhatsAppClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (typeof window !== 'undefined' && (window as any).gtag_report_conversion) {
      (window as any).gtag_report_conversion(WA_LINK, true);
    } else {
      window.open(WA_LINK, '_blank');
    }
  };

  return (
    <section className="py-16 md:py-20 bg-gray-900" id="ajuda">
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
        <span className="inline-block text-green-400 text-xs font-black uppercase tracking-[0.2em] mb-3 border border-green-500/30 rounded-full px-4 py-1.5 bg-green-500/10">
          Atendimento Especializado
        </span>
        <h2 className="text-3xl md:text-4xl font-black text-white uppercase mb-5">
          Precisa de Ajuda para Escolher?
        </h2>
        <p className="text-gray-400 text-sm leading-relaxed max-w-lg mx-auto mb-8">
          Informe o material, a espessura e o tipo de aplicação. Nossa equipe pode ajudar você a encontrar o equipamento mais adequado.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={WA_LINK}
            target="_blank"
            rel="nofollow noreferrer"
            onClick={handleWhatsAppClick}
            className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-black text-sm px-6 py-3.5 rounded-xl transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide"
          >
            <i className="ri-whatsapp-line" />
            Falar com um Especialista
          </a>
          <a
            href={WA_LINK}
            target="_blank"
            rel="nofollow noreferrer"
            onClick={handleWhatsAppClick}
            className="flex items-center gap-2 border border-white/20 hover:border-white/40 text-white font-black text-sm px-6 py-3.5 rounded-xl transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide"
          >
            <i className="ri-file-text-line" />
            Solicitar Orçamento
          </a>
        </div>
      </div>
    </section>
  );
}